export default {
  eventsData: {
    en: {
    },
    es: {
      importantEventsTitle: 'Eventos destacados',
      comingEventsTitle: 'Últimos eventos',
    },
  },
};
